import {
  ARAMLAS_HOME_BENTO_CARD_SQUARE_CLASS,
  ARAMLAS_HOME_BENTO_CARD_TALL_CLASS,
  ARAMLAS_HOME_BENTO_GRID_CLASS,
  ARAMLAS_HOME_BENTO_SKELETON_SLOTS,
  ARAMLAS_HOME_CALENDAR_WRAPPER_CLASS,
  ARAMLAS_HOME_DAILY_MESSAGE_COMPACT_CLASS,
  ARAMLAS_HOME_DAILY_MESSAGE_EVERGREEN_SHELL_CLASS,
  ARAMLAS_HOME_GREETING_CARD_BACKGROUND_URL,
  ARAMLAS_HOME_RAIL_CLASS,
} from "@/lib/homeContentRail";
import { AramlasHomeShellLoadingFrame } from "@/components/aramlas/AramlasHomeShellLoadingFrame";
import { cn } from "@/lib/utils";

const SKELETON_SURFACE_CLASS = "bg-slate-100";

export function AramlasHomeGreetingSkeleton() {
  return (
    <div className="flex w-full items-center justify-center">
      <div
        aria-hidden
        className={cn(
          "w-4/5 max-w-md rounded-2xl",
          "h-[3.6rem] md:h-[3.25rem] lg:h-[4.4rem]",
          SKELETON_SURFACE_CLASS,
        )}
      />
    </div>
  );
}

export function AramlasHomeDailyMessageSkeleton() {
  return (
    <div
      aria-hidden
      data-testid="aramlas-home-daily-message-skeleton"
      className={cn(
        ARAMLAS_HOME_DAILY_MESSAGE_COMPACT_CLASS,
        ARAMLAS_HOME_DAILY_MESSAGE_EVERGREEN_SHELL_CLASS,
        "relative",
      )}
    >
      <img
        src={ARAMLAS_HOME_GREETING_CARD_BACKGROUND_URL}
        alt=""
        aria-hidden
        className="pointer-events-none absolute inset-0 h-full w-full object-cover object-center opacity-60"
      />
      <div className="relative z-10 flex flex-1 flex-col items-center justify-center p-6 sm:p-10">
        <div className="mx-auto flex w-full max-w-[17.5rem] items-center justify-center sm:max-w-[23rem] md:max-w-[28rem]">
          <div className={cn("h-8 w-[88%] rounded-lg", SKELETON_SURFACE_CLASS)} />
        </div>
      </div>
    </div>
  );
}

export function AramlasHomeBentoGridSkeleton() {
  return (
    <div aria-hidden className={ARAMLAS_HOME_BENTO_GRID_CLASS}>
      {ARAMLAS_HOME_BENTO_SKELETON_SLOTS.map((slot, index) => (
        <div
          key={`aramlas-home-bento-skeleton-${index}`}
          data-testid={
            index === ARAMLAS_HOME_BENTO_SKELETON_SLOTS.length - 1
              ? "aramlas-home-bento-skeleton-continue"
              : undefined
          }
          className={cn(
            "w-full overflow-hidden",
            slot === "square"
              ? ARAMLAS_HOME_BENTO_CARD_SQUARE_CLASS
              : ARAMLAS_HOME_BENTO_CARD_TALL_CLASS,
            SKELETON_SURFACE_CLASS,
          )}
        />
      ))}
    </div>
  );
}

export function AramlasHomeCalendarSkeleton() {
  return (
    <div aria-hidden className={ARAMLAS_HOME_CALENDAR_WRAPPER_CLASS}>
      <div className="overflow-hidden rounded-[28px] border border-black/[0.06] bg-white">
        <div className="flex items-center justify-between gap-4 px-5 pb-2 pt-3 sm:px-6 sm:pt-3.5">
          <div className={cn("h-7 w-24 rounded-lg", SKELETON_SURFACE_CLASS)} />
          <div className={cn("h-11 w-16 rounded-full", SKELETON_SURFACE_CLASS)} />
        </div>
        <div className="space-y-2 px-3 pb-4 sm:px-4 sm:pb-5">
          <div className="space-y-2 rounded-[22px] border border-black/[0.06] bg-white px-2 py-2">
            {[1, 2].map((i) => (
              <div key={i} className="flex items-center gap-3 px-1 py-1 sm:gap-4">
                <div className={cn("aspect-[16/9] w-24 shrink-0 rounded-[10px] sm:w-28 sm:rounded-[12px] md:w-36 md:rounded-[14px]", SKELETON_SURFACE_CLASS)} />
                <div className="min-w-0 flex-1 space-y-2">
                  <div className={cn("h-3 w-24 rounded-md", SKELETON_SURFACE_CLASS)} />
                  <div className={cn("h-4 w-full rounded-md", SKELETON_SURFACE_CLASS)} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export function AramlasHomeShellSkeleton({ className }: { className?: string }) {
  return (
    <AramlasHomeShellLoadingFrame>
      <div
        data-testid="aramlas-home-shell-skeleton"
        className={cn(ARAMLAS_HOME_RAIL_CLASS, className)}
      >
        <AramlasHomeGreetingSkeleton />
        <AramlasHomeDailyMessageSkeleton />
        <AramlasHomeBentoGridSkeleton />
        <AramlasHomeCalendarSkeleton />
      </div>
    </AramlasHomeShellLoadingFrame>
  );
}
